import React from 'react'
import { Icon } from '../../../shared/tr-icons'
import Draggable from 'react-draggable'
import ScrollerMobileContainer from './ScrollerMobile.container'

import {
  ScrollBar,
  ScrollTrack,
  ScrollButtonLeft,
  ScrollButtonRight,
  ScrollButtons

} from './Scroller.styles'

const ScrollerComponent = ({ events, position, width, mobile, scrollHandle, setOffset, headers, rowActions, analytics }) => {
  return (
    <ScrollBar style={width}>
      <ScrollTrack>
        {!mobile && scrollHandle &&
          <Draggable axis='x' bounds='parent' onDrag={events.handleDrag} onMouseDown={events.resetDragOverride} position={position}>
            {scrollHandle}
          </Draggable>
        }
      </ScrollTrack>

      {!mobile && scrollHandle &&
        <ScrollButtons>
          <ScrollButtonLeft onClick={events.handleScrollLeftClick}>
            <Icon type='caretUp' />
          </ScrollButtonLeft>
          <ScrollButtonRight onClick={events.handleScrollRightClick}>
            <Icon type='caretUp' />
          </ScrollButtonRight>
        </ScrollButtons>
      }
      {mobile &&
        <ScrollerMobileContainer
          rowActions={rowActions}
          setOffset={setOffset}
          headers={headers}
          events={events}
          scrollHandle={scrollHandle}
        />
      }

    </ScrollBar>
  )
}

export default ScrollerComponent
